module.exports = __webpack_public_path__ + "img/google.a569f1ff.png";